export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetlerimiz',
      catalog: 'Katalog',
      about: 'Hakkımızda',
      contact: 'İletişim'
    },
    hero: {
      title: 'Endüstriyel Makine ve Özel İmalat Çözümleri',
      subtitle: 'NanoGen; konveyör, helezon, çikolata makineleri ve CNC işleme alanlarında güvenilir üretim sunar.',
      cta: 'Teklif Al'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Endüstriyel üretimde kapsamlı çözümler sunuyoruz',
      conveyor: {
        title: 'Konveyör Sistemleri',
        description: 'Gıda, ilaç ve endüstriyel tesisler için özel tasarım konveyör bantları ve taşıma sistemleri. Hijyenik, dayanıklı ve verimli çözümler.'
      },
      helical: {
        title: 'Helezon (Vida) Sistemleri',
        description: 'Toz, granül ve parçacıklı malzemelerin taşınması için paslanmaz çelik helezon sistemleri. Özel ölçü ve tasarım imkanı.'
      },
      chocolate: {
        title: 'Çikolata ve Gıda Makineleri',
        description: 'Çikolata üretim hattı makineleri, temperleme, kalıplama ve paketleme sistemleri. Gıda standartlarına uygun hijyenik tasarım.'
      },
      cnc: {
        title: 'CNC İşleme',
        description: 'Hassas CNC torna, freze ve işleme merkezi hizmetleri. Yüksek tolerans gerektiren parça üretimi ve prototipleme.'
      },
      custom: {
        title: 'Özel Makine İmalatı',
        description: 'İhtiyacınıza özel tasarım ve imalat. Proje geliştirme, mühendislik ve üretim süreçlerinde tam destek.'
      },
      metal: {
        title: 'Metal İşleme',
        description: 'Kaynak, bükme, kesme ve montaj işlemleri. Paslanmaz çelik, alüminyum ve çelik konstrüksiyon imalatı.'
      }
    },
    whyUs: {
      title: 'Neden NanoGen?',
      experience: {
        title: 'Tecrübe',
        description: '2000 yılından bu yana sektörde'
      },
      quality: {
        title: 'Kaliteli Üretim',
        description: 'Uluslararası standartlarda imalat'
      },
      delivery: {
        title: 'Zamanında Teslim',
        description: 'Proje takvimlerine sadık kalıyoruz'
      },
      custom: {
        title: 'Özel Çözümler',
        description: 'Müşteriye özel tasarım ve üretim'
      }
    },
    references: {
      title: 'Çalıştığımız Firmalar',
      subtitle: 'Türkiye\'nin önde gelen firmalarına hizmet veriyoruz'
    },
    catalog: {
      title: 'Özel Tasarım Ürün Kataloğu',
      subtitle: 'Ürettiğimiz makineler ve sistemler',
      viewDetails: 'Detayları Gör'
    },
    about: {
      title: 'Hakkımızda',
      story: 'NanoGen, 2000 yılında kurulmuş, endüstriyel makine imalatı alanında uzmanlaşmış bir firmadır. Konveyör sistemleri, helezon (vida) sistemleri, çikolata ve gıda makineleri, CNC işleme, özel makine imalatı ve metal işleme konularında geniş bir yelpazede hizmet sunmaktayız.',
      mission: 'Müşterilerimizin üretim süreçlerini en üst seviyede verimli ve güvenilir hale getirmek için özel tasarım çözümler üretiyoruz. Kalite, güvenilirlik ve müşteri memnuniyeti ilkelerimizin temelini oluşturur.',
      values: 'Ülker Çikolata, Godiva, Ülker Bisküvi, Önem Gıda gibi Türkiye\'nin önde gelen firmalarına hizmet vermenin gururunu yaşıyoruz. Her projede müşteri odaklı yaklaşım, teknik mükemmeliyet ve zamanında teslimat taahhüdümüzü yerine getiriyoruz.'
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Projeleriniz için bizimle iletişime geçin',
      form: {
        name: 'Ad Soyad',
        email: 'E-posta',
        phone: 'Telefon',
        subject: 'Konu',
        message: 'Mesajınız',
        send: 'Gönder',
        sending: 'Gönderiliyor...',
        success: 'Mesajınız başarıyla gönderildi!',
        error: 'Bir hata oluştu. Lütfen tekrar deneyin.'
      },
      info: {
        phone: 'Telefon',
        email: 'E-posta',
        address: 'Adres'
      }
    },
    footer: {
      description: 'Endüstriyel makine imalatında güvenilir çözüm ortağınız.',
      quickLinks: 'Hızlı Bağlantılar',
      legal: 'Yasal',
      privacy: 'Gizlilik Politikası',
      cookies: 'Çerez Politikası',
      kvkk: 'KVKK',
      rights: 'Tüm hakları saklıdır.'
    },
    privacy: {
      title: 'Gizlilik Politikası',
      content: 'NanoGen olarak kişisel verilerinizin güvenliğine önem veriyoruz. Bu gizlilik politikası, web sitemizi ziyaret ettiğinizde toplanan bilgilerin nasıl kullanıldığını açıklamaktadır.'
    },
    cookies: {
      title: 'Çerez Politikası',
      content: 'Web sitemizde çerezler kullanarak size daha iyi bir deneyim sunmayı amaçlıyoruz. Çerezler, sitemizi nasıl kullandığınızı anlamamıza yardımcı olur.'
    },
    kvkk: {
      title: 'KVKK Aydınlatma Metni',
      content: 'NanoGen olarak 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel verilerinizi korumak için gerekli tüm önlemleri alıyoruz.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      catalog: 'Catalog',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      title: 'Industrial Machinery and Custom Manufacturing Solutions',
      subtitle: 'NanoGen provides reliable production in conveyor, helical, chocolate machinery and CNC machining.',
      cta: 'Get Quote'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions in industrial manufacturing',
      conveyor: {
        title: 'Conveyor Systems',
        description: 'Custom-designed conveyor belts and transport systems for food, pharmaceutical and industrial facilities. Hygienic, durable and efficient solutions.'
      },
      helical: {
        title: 'Helical (Screw) Systems',
        description: 'Stainless steel helical systems for transporting powder, granules and particulate materials. Custom size and design options available.'
      },
      chocolate: {
        title: 'Chocolate and Food Machinery',
        description: 'Chocolate production line machinery, tempering, molding and packaging systems. Hygienic design compliant with food standards.'
      },
      cnc: {
        title: 'CNC Machining',
        description: 'Precision CNC turning, milling and machining center services. Production of parts requiring high tolerance and prototyping.'
      },
      custom: {
        title: 'Custom Machine Manufacturing',
        description: 'Custom design and manufacturing for your needs. Full support in project development, engineering and production processes.'
      },
      metal: {
        title: 'Metal Processing',
        description: 'Welding, bending, cutting and assembly operations. Stainless steel, aluminum and steel construction manufacturing.'
      }
    },
    whyUs: {
      title: 'Why NanoGen?',
      experience: {
        title: 'Experience',
        description: 'In the industry since 2000'
      },
      quality: {
        title: 'Quality Production',
        description: 'Manufacturing to international standards'
      },
      delivery: {
        title: 'On-Time Delivery',
        description: 'We stay committed to project schedules'
      },
      custom: {
        title: 'Custom Solutions',
        description: 'Custom design and production for clients'
      }
    },
    references: {
      title: 'Companies We Work With',
      subtitle: 'Serving Turkey\'s leading companies'
    },
    catalog: {
      title: 'Custom Design Product Catalog',
      subtitle: 'Machines and systems we manufacture',
      viewDetails: 'View Details'
    },
    about: {
      title: 'About Us',
      story: 'NanoGen is a company established in 2000, specializing in industrial machinery manufacturing. We offer a wide range of services in conveyor systems, helical (screw) systems, chocolate and food machinery, CNC machining, custom machine manufacturing and metal processing.',
      mission: 'We produce custom design solutions to make our customers\' production processes highly efficient and reliable. Quality, reliability and customer satisfaction form the basis of our principles.',
      values: 'We are proud to serve Turkey\'s leading companies such as Ülker Chocolate, Godiva, Ülker Biscuit, and Önem Food. In every project, we fulfill our commitment to customer-focused approach, technical excellence and on-time delivery.'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us for your projects',
      form: {
        name: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Your Message',
        send: 'Send',
        sending: 'Sending...',
        success: 'Your message has been sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      info: {
        phone: 'Phone',
        email: 'Email',
        address: 'Address'
      }
    },
    footer: {
      description: 'Your reliable solution partner in industrial machinery manufacturing.',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      kvkk: 'Data Protection',
      rights: 'All rights reserved.'
    },
    privacy: {
      title: 'Privacy Policy',
      content: 'As NanoGen, we care about the security of your personal data. This privacy policy explains how the information collected when you visit our website is used.'
    },
    cookies: {
      title: 'Cookie Policy',
      content: 'We use cookies on our website to provide you with a better experience. Cookies help us understand how you use our site.'
    },
    kvkk: {
      title: 'Data Protection Notice',
      content: 'As NanoGen, we take all necessary measures to protect your personal data within the scope of the Personal Data Protection Law No. 6698.'
    }
  }
};
